module.exports = __webpack_public_path__ + "media/components/assets/icons/coldcall_question-4de24fdc70cee7be8c4e09c9b270f0e8.svg";